import { Box, Flex, Text } from "@engaging-tech/components"
import styled from "styled-components"

export const TableWrapper = styled(Flex)`
  max-width: 1280px;
  gap: 20px;
  padding: 0 20px;
`

export const DesktopBoxWrapper = styled(Flex)`
  display: none;
  max-width: 1280px;
  gap: 20px;
  padding: 0 20px;
  align-items: center;

  @media (min-width: 1024px) {
    display: flex;
  }
`

export const CustomBox = styled(Box)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

export const PlaceholderDiv = styled(Box)`
  width: 240px;
  flex-shrink: 0;
`
export const CustomFlex = styled(Flex)`
  gap: 10px;
`

export const HappiestWorkplacesButton = styled.div`
  @media (min-width: 1024px) {
    display: none;
  }

  @media (min-width: 1536px) {
  }
`

export const AwardsText = styled(Text)`
  display: none;

  @media (min-width: 1024px) {
    display: block;
    grid-column-start: 5;
    grid-column-end: 6;
    text-align: right;
  }

  @media (min-width: 1536px) {
    grid-column-start: 7;
    grid-column-end: 8;
  }
`

export const AwardsGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 16px;
  align-items: center;

  @media (min-width: 640px) {
    grid-template-columns: repeat(8, 1fr);
  }

  @media (min-width: 1024px) {
    grid-gap: 20px;
    grid-template-columns: repeat(12, 1fr);
  }

  @media (min-width: 1536px) {
    grid-template-columns: repeat(16, 1fr);
  }
`

export const AwardRankingBannerWrapper = styled.div`
  width: 100%;
  background-color: #e1f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  gap: 20px;
`

export const TextSearchInputBox = styled.div`
  grid-column-start: 1;
  grid-column-end: 4;

  @media (min-width: 640px) {
    grid-column-start: 1;
    grid-column-end: 8;
  }

  @media (min-width: 1024px) {
    grid-column-start: 2;
    grid-column-end: 5;
  }

  @media (min-width: 1536px) {
    grid-column-start: 4;
    grid-column-end: 7;
  }

  > div {
    flex-direction: row-reverse;
  }

  div > div {
    margin-left: 0px;
    margin-right: 10px;
  }
`

export const AwardsCategoryFilterBox = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: block;
    grid-column-start: 6;
    grid-column-end: 8;
  }

  @media (min-width: 1536px) {
    grid-column-start: 8;
    grid-column-end: 10;
  }
`

export const AwardsCountryFilterBox = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: block;
    grid-column-start: 8;
    grid-column-end: 10;
  }

  @media (min-width: 1536px) {
    grid-column-start: 10;
    grid-column-end: 12;
  }
`

export const AwardsIndustryFilterBox = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: block;
    grid-column-start: 10;
    grid-column-end: 12;
  }

  @media (min-width: 1536px) {
    grid-column-start: 12;
    grid-column-end: 14;
  }
`

export const AwardsYearFilterBox = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: block;
    grid-column-start: 12;
    grid-column-end: 13;
  }

  @media (min-width: 1536px) {
    grid-column-start: 14;
    grid-column-end: 15;
  }
`

export const LoadMoreWrapper = styled(Flex)`
  width: 100%;
  height: 60px;

  margin-bottom: 20px;

  justify-content: center;
  align-items: center;
`
